import { getEmojiStore } from 'widget/stores/EmojiStore/EmojiStore';

// Стор используется как синглтон, хук позволяет использовать стор в принятом в проекте стиле
export const useEmojiStore = () => getEmojiStore();
